import React, { useState } from "react";
import { FaSpinner, FaTimes } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { BsExclamationLg } from "react-icons/bs";
import { MdCancel } from "react-icons/md";
import { formatNumberWithCommas } from "../../../utils/commonUtils";
import {
  cancelManualTransfer,
  fetchManualTransfer,
} from "../../../redux/slices/manualTransferSlice";
import { pushNotifyUser } from "../../../redux/slices/pushSlice";

export default function CancelWalletManualTransfer({
  id,
  name,
  amount,
  user_id,
}) {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);

  const status = useSelector((state) => state.payment?.status);

  const dispatch = useDispatch();

  const handleCancelSubmit = async () => {
    try {
      const res = await dispatch(cancelManualTransfer(id)); // <-- Cancel action
      if (res.payload) {
        const pushNote = {
          user_id: [user_id],
          title: "Capfields Evolve",
          body: `Your manual payment of ₦${amount} has been declined. Kindly verify and try again.`,
          click: "USER",
        };
        dispatch(pushNotifyUser(pushNote));
        await dispatch(fetchManualTransfer());
        toast.success(res.payload.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to cancel manual transfer.");
    }
    setShowCancelModal(false);
  };

  return (
    <>
      <div className="flex items-center">
        <button type="button" onClick={() => setShowConfirmModal(true)}>
          <MdCancel className="text-red-600 text-2xl" />
        </button>
      </div>

      {showConfirmModal && (
        <>
          <div className="fixed inset-0 z-50 flex justify-center items-center">
            <div className="bg-white p-8 rounded-lg shadow-lg relative w-[400px]">
              <button
                type="button"
                onClick={() => setShowConfirmModal(false)}
                className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
              >
                <FaTimes />
              </button>
              <h1 className="text-xl font-semibold text-center mb-4">
                Cancel Manual Transfer?
              </h1>
              <p className="text-center text-gray-600">
                Do you really want to cancel this wallet manual transfer?
              </p>
              <div className="flex justify-center items-center my-4">
                <BsExclamationLg className="text-red-500 text-3xl" />
              </div>
              <div className="flex justify-center gap-4">
                <button
                  onClick={() => setShowConfirmModal(false)}
                  className="bg-gray-100 text-gray-600 px-4 py-2 rounded-md text-sm"
                >
                  No
                </button>
                <button
                  onClick={() => {
                    setShowConfirmModal(false);
                    setShowCancelModal(true);
                  }}
                  className="bg-red-600 text-white px-4 py-2 rounded-md text-sm"
                >
                  Yes, Cancel
                </button>
              </div>
            </div>
          </div>
          <div className="fixed inset-0 bg-black opacity-25 z-40"></div>
        </>
      )}

      {showCancelModal && (
        <>
          <div className="fixed inset-0 z-50 flex justify-center items-center">
            <div className="bg-white p-10 rounded-lg shadow-lg relative w-[400px]">
              <button
                type="button"
                onClick={() => setShowCancelModal(false)}
                className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
              >
                <FaTimes />
              </button>
              <h1 className="text-xl font-semibold text-center mb-2">
                Confirm Cancellation
              </h1>
              <p className="text-center mb-4 text-gray-600">
                This action will cancel the manual transfer request for:
              </p>
              <div className="text-sm mb-4 space-y-2">
                <p>
                  <strong>User:</strong> {name}
                </p>
                <p>
                  <strong>Amount:</strong> ₦{formatNumberWithCommas(amount)}
                </p>
              </div>
              <div className="flex justify-center gap-4">
                <button
                  onClick={() => setShowCancelModal(false)}
                  className="bg-gray-100 text-gray-600 px-4 py-2 rounded-md text-sm"
                >
                  Back
                </button>
                <button
                  disabled={status === "loading"}
                  onClick={handleCancelSubmit}
                  className="flex items-center gap-2 bg-red-600 text-white px-4 py-2 rounded-md text-sm"
                >
                  {status === "loading" ? (
                    <>
                      <FaSpinner className="animate-spin" />
                      Cancelling...
                    </>
                  ) : (
                    <>
                      <FaTimes className="w-4 h-4" />
                      Cancel Transfer
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
          <div className="fixed inset-0 bg-black opacity-25 z-40"></div>
        </>
      )}
    </>
  );
}
